import type { MenuProps } from "antd";
import ROUTES from "../routes";
import Icon from "../components/Icon";
import { UserType } from "./constants";
import { IUser } from "../types/User";
import { i18n } from "i18next";

type MenuItem = Required<MenuProps>["items"][number];

const home = {
  label: "Home",
  route: ROUTES.PATHS.SL_HOME,
  icon: "home",
  fillIcon: "home_fill",
};
const profile = {
  label: "Profile",
  route: ROUTES.PATHS.PROFILE,
  icon: "manage_accounts"
};
const settings = {
  label: "Settings",
  route: ROUTES.PATHS.SERIALNO_SETTINGS,
  icon: "settings",
  fillIcon: "settings_fill",
};
const customerMenus = [
  home,
  {
    label: "History",
    route: ROUTES.PATHS.CUSTOMER_SERVICES,
    icon: "history",
    fillIcon: "history"
  },
  settings,
  profile
];

const companyMenus = [
  home,
  {
    label: "Service Centers",
    route: ROUTES.PATHS.SERVICE_CENTERS,
    icon: "domain",
    fillIcon: "domain_fill"
  },
  {
    label: "Service Types",
    route: ROUTES.PATHS.SERVICE_TYPES,
    icon: "hub",
    fillIcon: "hub_fill"
  },
  {
    label: "Service Men",
    route: ROUTES.PATHS.SERVICE_MEN,
    icon: "group",
    fillIcon: "group_fill"
  },
  {
    label: "Offdays",
    route: ROUTES.PATHS.OFF_DAYS,
    icon: "menu",
    fillIcon: "menu"
  },
  settings,
  profile
];

const developerMenus = [
  home,
  {
    label: "Companies",
    route: ROUTES.PATHS.DEVELOPER_COMPANIES,
    icon: "home",
    fillIcon: "home_fill"
  },
  {
    label: "Modules",
    route: ROUTES.PATHS.MODULES,
    icon: "home",
    fillIcon: "home_fill"
  },
  {
    label: "Subscriptions",
    route: ROUTES.PATHS.SUBSCRIPTIONS,
    icon: "home",
    fillIcon: "home_fill"
  },
  {
    label: "Locations",
    route: ROUTES.PATHS.DEVELOPER_LOCATIONS,
    icon: "home",
    fillIcon: "home_fill"
  },
];

export const leftMenuItems = (pathname: string, i18n: i18n, loggedInUser: IUser | null) => {
  const menuItems = [];
  if (loggedInUser?.userType === UserType.Developer) {
    menuItems.push(...developerMenus.map((item: any) => (
      {
        key: item.route,
        icon: <Icon icon={pathname === item.route ? item.fillIcon || item.icon : item.icon} className="h-5 w-5" />,
        label: i18n.t(item.label)
      } as MenuItem
    )))
  }
  else if (loggedInUser?.userType === UserType.Company) {
    menuItems.push(...companyMenus.map((item: any) => (
      {
        key: item.route,
        icon: <Icon icon={pathname === item.route ? item.fillIcon || item.icon : item.icon} className="h-5 w-5" />,
        label: i18n.t(item.label),
      } as MenuItem
    )))
  } else {
    menuItems.push(...customerMenus.map((item: any) => (
      {
        key: item.route,
        icon: <Icon icon={pathname === item.route ? item.fillIcon || item.icon : item.icon} className="h-5 w-5" />,
        label: i18n.t(item.label)
      } as MenuItem
    )));
  }

  return menuItems;
};

export const buildHeaderMenuItems = (i18n: i18n, loggedInUser: IUser | null) => {
  const headerItems: MenuItem[] = [
    {
      key: "PROFILE",
      label: i18n.t("Profile"),
    },
    {
      key: "LOGOUT",
      label: i18n.t("Logout"),
    }
  ];
  return headerItems;
};

export const bottomMenuItems = (pathname: string, i18n: i18n, loggedInUser: IUser | null, menuLength: number = 4) => {
  const menus = loggedInUser?.userType === UserType.Company ?
    companyMenus : (loggedInUser?.userType === UserType.Customer ? customerMenus : developerMenus) as any[];
  const menuItems = [];
  let length = menus.length > menuLength ? menuLength : menus.length;
  if (menus.length - menuLength === 1) {
    length++;
  }
  for (let i = 0; i < length; i++) {
    const item = menus[i] as any;
    menuItems.push({
      label: i18n.t(item.label),
      icon: pathname === item.route ? item.fillIcon || item.icon : item.icon,
      path: item.route,
      className: pathname === item.route ? "bg-secondary" : ""
    });
  }

  return menuItems;
}

export const bottomExtraMenuItems = (pathname: string, i18n: i18n, loggedInUser: IUser | null, menuLength: number = 4) => {
  const menus = loggedInUser?.userType === UserType.Company ?
    companyMenus : (loggedInUser?.userType === UserType.Customer ? customerMenus : developerMenus) as any[];
  const menuItems = [];
  if (menus.length - menuLength === 1) {
    menuLength++;
  }
  for (let i = menuLength; i < menus.length; i++) {
    menuItems.push(
      {
        label: i18n.t(menus[i].label),
        icon: pathname === menus[i].route ? menus[i].fillIcon || menus[i].icon : menus[i].icon,
        path: menus[i].route,
        className: pathname === menus[i].route ? "bg-secondary" : "",
      });
  }

  return menuItems;
}